export default __webpack_public_path__ + "static/4-069f7754a8c3b266ef804ab82612a5b4.jpg";